import {useState} from "react";
import {useLocation} from "react-router-dom";
import {useMutation} from "@apollo/client";
import {
    Button,
    Dialog, DialogActions,
    DialogContent,
    DialogTitle,
    Typography
} from "@mui/material";

import {GET_ALL_CONTENT_DATA, MOVE_CONTENT_FOLDER} from "../../../queries/GraphQLQueries";
import CustomAlert from "../../CustomAlert";
import {useDialogNavigation} from "../../../hooks/useDialogNavigation";

export default function MoveContentFolderDialog() {
    const handleClose = useDialogNavigation();
    const {state} = useLocation();

    const [alertMessage, setAlertMessage] = useState(null);
    const {sourceNodeId, sourceNodeName, targetNodeId, targetNodeName} = state || {};

    const [moveContentFolderMutation] = useMutation(MOVE_CONTENT_FOLDER, {refetchQueries: [{ query: GET_ALL_CONTENT_DATA }, 'GetAllContentData']});

    const handleCloseCustomAlert = () => setAlertMessage(null);

    const handleMove = () => {
        moveContentFolderMutation({
            variables: {
                contentFolderId: sourceNodeId,
                newParentContentFolderId: targetNodeId
            }
        }).then(() => handleClose())
        .catch((e) => {
            setAlertMessage({children: e?.message, severity: 'error'});
            return false;
        });
    }

    return (
      <>
          <Dialog open={true} onClose={handleClose}>
              <DialogTitle>Move Content Folder</DialogTitle>

              <DialogContent>
                  <Typography variant={"body"}>{`This will move Content Folder '${sourceNodeName}' under '${targetNodeName}'. Are you sure you want to proceed?`}</Typography>
              </DialogContent>
              <DialogActions>
                  <Button onClick={handleClose} variant="contained">Cancel</Button>
                  <Button onClick={handleMove} variant="contained">Move</Button>
              </DialogActions>
          </Dialog>
          <CustomAlert alertMessage={alertMessage} handleCloseCustomAlert={handleCloseCustomAlert}/>
      </>
    );
}
